import { Controller } from "@hotwired/stimulus"

// Define the FilterFormController class
export default class extends Controller<HTMLFormElement> {
    static targets = ["checkbox", "input"]

    declare readonly checkboxTargets: HTMLInputElement[]
    declare readonly inputTargets: HTMLInputElement[]

    // Debounce timeout identifier
    debounceTimeout: number | null = null

    // Debounce delay in milliseconds
    debounceDelay: number = 300

    connect(): void {
        this.initializeCheckboxListeners()
    }

    initializeCheckboxListeners(): void {
        this.checkboxTargets.forEach((checkbox) => {
            checkbox.addEventListener("change", this.debouncedSubmitForm.bind(this))
        });

        this.inputTargets.forEach((input) => {
            input.addEventListener("change", this.debouncedSubmitForm.bind(this))
        });
    }

    debouncedSubmitForm(): void {
        console.log('submit should be called');

        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout)
        }
        this.debounceTimeout = window.setTimeout(() => {
            this.submitForm()
        }, this.debounceDelay)
    }

    submitForm(): void {
        this.element.requestSubmit();
    }
}
